'use strict';

var React = require('react');

function _interopNamespace(e) {
	if (e && e.__esModule) return e;
	var n = Object.create(null);
	if (e) {
		Object.keys(e).forEach(function (k) {
			if (k !== 'default') {
				var d = Object.getOwnPropertyDescriptor(e, k);
				Object.defineProperty(n, k, d.get ? d : {
					enumerable: true,
					get: function () { return e[k]; }
				});
			}
		});
	}
	n["default"] = e;
	return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SvgCode = props => /*#__PURE__*/React__namespace.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  overflow: "visible",
  preserveAspectRatio: "none",
  viewBox: "0 0 24 24",
  height: 24,
  width: 24
}, props), _path || (_path = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M8.43 16.59c.13-.13.14-.33.01-.47l-.01-.01-4.09-4.09 4.09-4.09c.13-.13.14-.33.01-.47l-.01-.01-.52-.52a.332.332 0 0 0-.47-.01l-.01.01-4.85 4.85c-.13.13-.14.33-.01.47l.01.01 4.85 4.85c.13.13.33.14.47.01l.01-.01.52-.52zm6.15-11.11c.04-.08.04-.18 0-.26a.353.353 0 0 0-.23-.2l-.65-.18a.331.331 0 0 0-.24 0c-.08.04-.13.12-.16.2L9.42 18.56c-.04.08-.04.18 0 .26.04.08.12.13.2.16l.65.18c.08.03.16.03.24 0 .08-.04.13-.12.16-.2l3.91-13.48zm6.84 6.78c.13-.13.14-.33.01-.47l-.01-.01-4.85-4.85a.332.332 0 0 0-.47-.01l-.01.01-.52.52c-.13.13-.14.33-.01.47l.01.01 4.09 4.09-4.09 4.09c-.13.13-.14.33-.01.47l.01.01.52.52c.13.13.33.14.47.01l.01-.01 4.85-4.85z",
  vectorEffect: "non-scaling-stroke",
  fill: "currentColor"
})));

exports["default"] = SvgCode;
